import { createAction, props } from '@ngrx/store'
import { Competition, Season } from '@core/models/season-competition.models'
import { TeamComparisonRequest } from '@pages/team/models/team.models'

export const fetchTeamMetricFinderData = createAction('[MetricFinder] fetch team metrics data')

export const fetchTeamMetricFinderHolder = createAction(
  '[MetricFinder] fetch team holder',
  props<{ season: Season; competition: Competition; teamId: string }>()
)
export const fetchTeamMetricFinderMetrics = createAction(
  '[MetricFinder] fetch team metrics',
  props<{ seasonId: string; competitionId: string; teamId: string }>()
)

export const fetchFavTeamMetricFinderMetrics = createAction('[MetricFinder] fetch fav team metrics')
export const fetchFavTeamComparisonMetricFinderMetrics = createAction(
  '[MetricFinder] fetch fav team comparison metrics',
  props<{ seasonIdB: string; competitionIdB: string; teamIdB: string }>()
)

export const fetchTeamComparisonMetricFinderMetrics = createAction(
  '[MetricFinder] fetch team comparison metrics',
  props<{
    toCompare: TeamComparisonRequest
  }>()
)
